import type { Service, ManifestoChapter, Stat } from "@/types";
import {
  Palette,
  AppWindow,
  Smartphone,
  Boxes,
  Contact,
  BrainCircuit,
  Workflow,
  Cloud,
  Server,
  LifeBuoy,
} from "@/icons";




export const heroDescription =
"VibeWell Software Solutions helps businesses transform ideas into scalable digital solutions through custom software, AI-powered automation, modern web applications, mobile applications and cloud technologies."

export const heroHeading = [
  "Transforming Ideas Into",
  "AI-Powered Business Solutions.",
  // "",
];

// const heroStats = [
//   { value: "120+", label: "Products shipped" },
//   { value: "98%", label: "Client retention" },
//   { value: "9x", label: "Faster delivery" },
// ];
export const heroStats = [
  {
    value: "Web",
    label: "Websites & Portals",
  },
  {
    value: "Apps",
    label: "Enterprise Software",
  },
  {
    value: "AI",
    label: "Automation Solutions",
  },
  {
    value: "Cloud",
    label: "Infrastructure & DevOps",
  },
];

/** Core service offerings (homepage services grid). */
export const services: Service[] = [
  {
    id: "website-design",
    title: "Website Design & Development",
    summary:
      "Modern, responsive websites designed to strengthen your brand, engage customers, and generate measurable business growth.",
    icon: Palette,
    best_for: "Startups • SMEs • Corporate Websites • E-Commerce • Professional Services",
  },
  {
    id: "web-applications",
    title: "Custom Web Applications",
    summary:
      "Scalable, secure and intelligent web applications designed around your unique business processes, helping you automate operations, improve productivity and support long-term growth.",
    icon: AppWindow,
    best_for: "Business Process Automation • Customer Portals • Enterprise Systems • SaaS Platforms",
  },
  {
    id: "mobile-apps",
    title: "Mobile App Development",
    summary: "Design and develop secure, high-performance mobile applications that improve customer engagement, streamline business operations and keep users connected wherever they are.",
    icon: Smartphone,
    best_for: "Retail • Healthcare • Logistics • Field Service • Consumer Apps",
  },
  {
    id: "erp",
    title: "ERP Solutions",
    summary: "Build a customised ERP platform that unifies business operations, automates workflows and provides real-time visibility across your organisation.",
    icon: Boxes,
    best_for: "Manufacturing • Healthcare • Education • Government • Hospitality",
  },
  {
    id: "crm",
    title: "CRM Solutions",
    summary: "Build a customised CRM platform that centralises customer information, streamlines sales and service operations, and helps your organisation build lasting customer relationships.",
    icon: Contact,
    best_for: "Sales Teams • Customer Support • Real Estate • Financial Services • Healthcare",
  },
  {
    id: "api-development",
    title: "API Development",
    summary: "Build secure, scalable and well-documented APIs that connect applications, automate business processes and enable seamless data exchange.",
    icon: Server,
    best_for: "Web Applications • Workflow Automation • Analytics",
  },
  {
    id: "ai-integration",
    title: "AI Solutions & Integration",
    summary: "Integrate practical AI solutions into your business to automate repetitive tasks, improve decision-making and deliver smarter digital experiences.",
    icon: BrainCircuit,
    best_for: "Customer Support • Workflow Automation • Analytics • Knowledge Management • Decision Support",
  },
  {
    id: "workflow-automation",
    title: "Business Process Automation",
    summary: "Automate repetitive business processes, connect disconnected systems and improve operational efficiency through intelligent workflow automation.",
    icon: Workflow,
    best_for: "HR • Finance • Procurement • Operations • Approval Workflows",
  },
  {
    id: "cloud-deployment",
    title: "Cloud Solutions & DevOps",
    summary: "Cloud infrastructure and DevOps services that ensure your applications remain secure, reliable, scalable, and ready for future growth.",
    icon: Cloud,
    best_for: "Best for Growing Businesses • SaaS Products • Enterprise Applications • High Availability Systems",
  },
  {
    id: "support",
    title: "Maintenance & Support",
    summary: "Keep your business applications secure, reliable and performing at their best with proactive maintenance, continuous monitoring and expert technical support.",
    icon: LifeBuoy,
    best_for: "Best for Business-Critical Applications • Enterprise Systems • Long-Term Software Support",
  },
];

/** Numbered manifesto chapters (retained for internal use). */
export const manifesto: ManifestoChapter[] = [
  {
    index: "01",
    title: "Design is a business decision",
    body: "Every pixel earns its place. We design toward outcomes — activation, retention, revenue — not decoration.",
  },
  {
    index: "02",
    title: "Engineering is craft",
    body: "We build software the way we design it: deliberate, tested and made to last well beyond launch day.",
  },
  {
    index: "03",
    title: "Momentum beats perfection",
    body: "We ship in tight loops, learn from real usage and compound small wins into durable growth.",
  },
  {
    index: "04",
    title: "Partnership over projects",
    body: "We embed with your team as one unit — transparent, senior and accountable to the same numbers.",
  },
];

export const stats: Stat[] = [
  {
    value: "Web",
    label: "Websites & Portals",
  },
  {
    value: "AI",
    label: "AI & Automation",
  },
  {
    value: "ERP",
    label: "Enterprise Solutions",
  },
  {
    value: "Cloud",
    label: "Cloud & DevOps",
  },
];

export const marqueeWords: string[] = [
  "Enterprise Software & AI Solutions",
  "Website Development",
  "Mobile Apps",
  "ERP Solutions",
  "CRM Solutions",
  "Workflow Automation",
  "Cloud Solutions",
  "Digital Transformation",
  "Technology Consulting",
];

export const technologyHighlights = [
  "React",
  "Next.js",
  "Node.js",
  "Python",
  "Docker",
  "FastAPI",
  "PostgreSQL",
  "Redis",
  "OpenAI",
  "n8n",
];

/** Headline metrics (animated counters). */
// export const stats: Stat[] = [
//   { value: "120+", label: "Products shipped" },
//   { value: "9x", label: "Avg. faster delivery" },
//   { value: "40+", label: "Global clients" },
//   { value: "98%", label: "Client retention" },
// ];

/** Marquee phrases for the editorial ticker. */
// export const marqueeWords: string[] = [
//   "Strategy",
//   "Product Design",
//   "Engineering",
//   "Design Systems",
//   "Mobile",
//   "Growth",
//   "Brand",
//   "Prototyping",
// ];

/** Client / partner wordmarks (text-based, no stock logos). */
// export const clientLogos: string[] = [
//   "Northwind",
//   "Lumen",
//   "Cascade",
//   "Vertex",
//   "Halcyon",
//   "Meridian",
// ];
